import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ApolloModule, APOLLO_OPTIONS } from "apollo-angular";
import { ApolloLink, InMemoryCache } from "@apollo/client/core";
import { HttpLink } from "apollo-angular/http";
import { environment } from "environments/environment";
import { setContext } from "@apollo/client/link/context";
import { Storage } from "@targx/libs/storage";

export const createApollo = (httpLink: HttpLink) => {
  const basic = setContext((operation, context) => ({
    headers: {
      Accept: "*/*",
    },
  }));

  const auth = setContext((operation, context) => {
    const token = Storage.get(environment.KEY_LOCAL_STORAGE);

    if (token === null) {
      return {};
    } else {
      return {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
    }
  });

  const link = ApolloLink.from([
    basic,
    auth,
    httpLink.create({
      uri: environment.graphql,
    }),
  ]);

  const cache = new InMemoryCache();

  return {
    link,
    cache,
  };
};

@NgModule({
  imports: [CommonModule],
  exports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})
export class GraphqlModule { }
